import { Image } from 'expo-image';
import React from 'react';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { useResponsiveScale } from '../../../contexts/ResponsiveScaleContext';

type FramePreviewSvgProps = {
  svgUrl: string;
  viewBox: { width: number; height: number };
  zIndex: number;
};

export const FramePreviewSvg = ({ svgUrl, viewBox, zIndex }: FramePreviewSvgProps) => {
  const { responsiveScaleSV, responsiveScale } = useResponsiveScale();

  const animatedStyle = useAnimatedStyle(() => ({
    width: viewBox.width * responsiveScaleSV.value,
    height: viewBox.height * responsiveScaleSV.value,
    zIndex,
    pointerEvents: 'none',
    position: 'absolute',
  }), [responsiveScaleSV, viewBox.width, viewBox.height, zIndex, responsiveScale]);

  return (
    <Animated.View style={animatedStyle}>
      <Image
        // @ts-ignore
        draggable={false}
        crossOrigin="anonymous"
        source={svgUrl}
        style={{ aspectRatio: viewBox.width / viewBox.height }}
        contentFit="contain"
        recyclingKey={svgUrl}
      />
    </Animated.View>
  );
};
